import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import styled from 'styled-components';
import "./App.css"
import ScrollToTop from "./functions/ScrollToTop";
import StartPage from "./components/pages/StartPage";

const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 0;
`;

function App() {
  return (
    <Router >
      <ScrollToTop />
      <Body>
        <Routes>
            <Route path="/" element={<StartPage />}/>
        </Routes>
      </Body>
    </Router>
    
  );
}

export default App;